/*
openbikebox Frontend
Copyright (C) 2021 binary butterfly GmbH

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import '../sass/base.scss'
import '../sass/webapp.scss'

import React from "react";
import ReactDOM from "react-dom/client";

import LocationTileSelector from './locations/LocationTileSelector';
import LocationView from './location/LocationView'
import { transformAttribute } from './Helpers';
import LocationMap from "./locations/LocationMap";
import {TranslationProvider} from "./translations/context";

document.addEventListener('DOMContentLoaded', function(event) {
    let reactObjects = {
        'obb-resource-select-box': LocationView,
        'obb-location-tiles-box': LocationTileSelector,
        'obb-location-map-box': LocationMap,
    };

    let language = document.documentElement.getAttribute('lang') ?? 'de';


    for (const [html_id, ReactClass] of Object.entries(reactObjects)) {
        let dom_obj = document.getElementById(html_id);
        if (dom_obj) {
            let props = {
                ...(((typeof obb_locations_data === typeof undefined)) ? {} : {localLocations: obb_locations_data}),
                ...(((typeof obb_user_data === typeof undefined)) ? {} : {localUser: obb_user_data}),
            };
            dom_obj.getAttributeNames().filter(key => key.substring(0, 5) === 'data-').forEach(key => {
                props[transformAttribute(key.substring(5))] = dom_obj.getAttribute(key)
            })
            const root = ReactDOM.createRoot(dom_obj);
            root.render(
                <TranslationProvider language={language.substring(0, 2)}>
                    <ReactClass {...props}/>
                </TranslationProvider>
            );
        }
    }
});
